module.exports = __webpack_public_path__ + "static/media/SocialMedia.57ec73a8.JPG";